// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5DUuKU_j","card":"_5D2MiqoZ","link":"_5DBajUT5","empty":"_5DzyDMBg"};